import React, { lazy, memo } from 'react';
import {  Routes, Route, Navigate } from 'react-router-dom';
import HomePage from '../../Homepage';
import Clients from '../../Clients';
import ServiceCoordinators from '../../ServiceCoordinator';
import Reports from '../../IFSPReports';
import AgeOutReports from '../../AgeOutReports'
import EdTeams from '../../EdTeam';
import ClientsByProvider from '../../ClientsByProvider';
import { useCurrentUser } from '../Contexts/UserContext';
import Therapists from '../../TherapistsAdmin';
import TherapistClients from '../../TherapistView/TherapistClients';
import TherapistIFSP from '../../TherapistView/TherapistIFSP';

const AppRoutes = memo(() => {

    const user = useCurrentUser();

    if(!user) return <div>Loading...</div>;

    return (
            <Routes>
                <Route path="/" element={<HomePage />} />
                        <Route path="/clients" element={<Clients />} />
                        <Route path="/therapists" element={<Therapists />} />
                        <Route path="/servicecoordinators" element={<ServiceCoordinators />} />
                        <Route path="/edteams" element={<EdTeams/>} />
                        <Route path="/ifspreports" element={<Reports />} />
                        <Route path="/ageoutreports" element={<AgeOutReports />} />
                        <Route path="/clientsbyprovider" element={<ClientsByProvider/>} />
                {user.role === "Therapist" && (
                    <>
                        <Route path="/therapistclients" element={<TherapistClients/>} />
                        <Route path="/therapistifsp" element={<TherapistIFSP />} />
                    </>
                )}
                <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
    );
});

export default AppRoutes;